import { handleDetailResponse, handleListResponse } from "./utils";
import { admin_id, AdminRoleId } from "./constants";

const MASKED_PHONE_PATTERN = /^\*+\d{4}$/;
const SUPER_ADMIN_ROLE_IDS = new Set([
  String(AdminRoleId || ""),
  String(admin_id || ""),
]);

/** Show only the last 4 digits of a phone number; mask the rest with asterisks. */
export const maskPhoneNumber = (value) => {
  if (value === null || value === undefined || value === "") return "N/A";
  const str = String(value).trim();
  // API may already return a masked value — avoid stripping * and re-masking to digits only.
  if (MASKED_PHONE_PATTERN.test(str)) return str;
  const digits = str.replace(/\D/g, "");
  if (digits.length < 4) return "N/A";
  const last4 = digits.slice(-4);
  return `${"*".repeat(Math.max(0, digits.length - 4))}${last4}`;
};

export const formatPhoneForRole = (value, shouldMask) => {
  if (value === null || value === undefined || value === "") return "N/A";
  return shouldMask ? maskPhoneNumber(value) : String(value);
};

export const shouldMaskPhoneForUser = ({
  permissionResponse,
  isAdmin = false,
  roleId = "",
}) => {
  const isSuperAdmin =
    isAdmin || SUPER_ADMIN_ROLE_IDS.has(String(roleId || "").trim());

  if (isSuperAdmin) {
    return false;
  }

  const hasMaskPermission = handleDetailResponse(
    handleListResponse(permissionResponse).filter(
      (item) => item.slug === "mask_phone_number",
    ),
  )?.permission;

  return Boolean(hasMaskPermission);
};
